import styled from "styled-components";
import { theme } from "@nordcloud/gnui";

export const SquareBulletList = styled.ul`
  list-style-type: square;
  padding-left: ${theme.spacing.spacing04};
`;
